import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';

import { MetavendedorRoutingModule } from './metavendedor-routing.module';
import { MetavendedorComponent } from './components/metavendedor/metavendedor.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { OpcionesCargaDialogComponent } from './components/opciones-carga-dialog/opciones-carga-dialog.component';
import { DetalleMetaDialogComponent } from './components/detalle-meta-dialog/detalle-meta-dialog.component';
import { LocalMetaVendedorService } from './services/local-meta-vendedor.service';

@NgModule({
  declarations: [
    MetavendedorComponent,
    ConfirmDialogComponent,
    OpcionesCargaDialogComponent,
    DetalleMetaDialogComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatRadioModule,
    MatExpansionModule,
    MatTooltipModule,
    MatListModule,
    MetavendedorRoutingModule
  ],
  providers: [
    LocalMetaVendedorService
  ]
})
export class MetavendedorModule { }
